import { Button, DatePicker, Flex, Form, Input, InputNumber, Modal, Select } from "antd";
import moment from "moment";
import { patch, put } from "../services/api";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";


export default function TransactionEdit({ isModalOpen, setIsModalOpen, onTransactionEdit, transaction, setTransaction, id }) {
  const humans = useSelector((state) => state.humans);
  const assets = useSelector((state) => state.assets);
  const services = useSelector((state) => state.services);
  const contracts = useSelector((state) => state.contracts);
  const [settled, setSettled] = useState(false);
  const [transactionType, setTransactionType] = useState("");

  useEffect(() => {
    if (transaction) {
      setSettled(transaction.settled || false);
      // Set transaction type based on which ID exists
      if (transaction.humanId) {
        setTransactionType('human');
      } else if (transaction.assetId) {
        setTransactionType('asset');
      } else if (transaction.serviceId) {
        setTransactionType('service');
      } else if (transaction.contractId) {
        setTransactionType('contract');
      }
    }
  }, [transaction]);

  if (!transaction) { return null; }
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setTransaction(null);
    setIsModalOpen(false);
  };

  const onFinish = async (values) => {
    const data = {
      ...values,
      amount: -values.amount,
      settled: Boolean(settled),
      startAt: values.startAt ? moment(values.startAt.unix() * 1000) : null,
      endAt: values.endAt ? moment(values.endAt.unix() * 1000).endOf('day') : null
    };
    if (values.transactionType) {
      delete data.transactionType;
    }
    if (!values.startAt) {
      delete data.startAt;
    }
    if (!values.endAt) {
      delete data.endAt;
    }
    const resp = await patch(`/transactions/${transaction.id}`, data);
    setIsModalOpen(false);
    onTransactionEdit();
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };




  const handleFormValuesChange = (changedValues, allValues) => {
    if ('transactionType' in changedValues) {
      setTransactionType(changedValues.transactionType);
      // alert(changedValues.transactionType);
    }
    if ('settled' in changedValues) {
      setSettled(changedValues.settled);
      // alert(changedValues.transactionType);
    }

    // You can handle other form field changes here if needed
  };
  if (!transaction) { return null; }
  return <Modal title="Edit Transaction" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[
    <Button type="primary" className="bold" form="editTransaction" key="submit" htmlType="submit">
      Submit
    </Button>
  ]}>
    <Form
      id="editTransaction"
      name="basic"
      layout="vertical"
      onFinish={onFinish}
      onValuesChange={handleFormValuesChange}
      onFinishFailed={onFinishFailed}
      autoComplete="off">

      <Flex gap={'middle'}>
        <Form.Item
          style={{ flex: 1 }}
          label="Transaction Type"
          name="transactionType"
          initialValue={transaction.humanId ? 'human' : transaction.assetId ? 'asset' : transaction.serviceId ? 'service' : transaction.contractId ? 'contract' : ''}
        >
          <Select>
            <Select.Option value="human">Human</Select.Option>
            <Select.Option value="asset">Asset</Select.Option>
            <Select.Option value="service">Service</Select.Option>
            <Select.Option value="contract">Contract</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          style={{ flex: 1 }}
          label={transactionType === 'contract' ? 'Select Contract' : transactionType === 'human' ? 'Select Human' : transactionType === 'asset' ? 'Select Asset' : transactionType === "service" ? 'Select Service' : 'Select'}
          name={transactionType === 'contract' ? 'contractId' : transactionType === 'human' ? 'humanId' : transactionType === 'asset' ? 'assetId' : transactionType === "service" ? 'serviceId' : ''}
          initialValue={transaction.humanId || transaction.assetId || transaction.serviceId || transaction.contractId}
          rules={[{
            required: true,
            message: 'Please select!',
          }]}>
          <Select>
            {
            transactionType === 'contract' ? contracts.map(c => <Select.Option key={c.id} value={c.id}>{c.name}</Select.Option>) :
              transactionType === 'human' ? humans.map(h => <Select.Option key={h.id} value={h.id}>{h.name}</Select.Option>) :
                transactionType === 'asset' ? assets.map(a => <Select.Option key={a.id} value={a.id}>{a.name}</Select.Option>) :
                  transactionType === "service" ? services.map(s => s && s.id && <Select.Option key={s.id} value={s.id}>{s.name}</Select.Option>) :
                    null
            }
          </Select>
        </Form.Item>
      </Flex>

      <Form.Item
        style={{ flex: 1 }}
        label="Transaction Name"
        name="name"
        initialValue={transaction.name}
        rules={[{
          required: true,
          message: 'Please input Transaction name!',
        }]}>
        <Input autoFocus={true} />
      </Form.Item>

      <Form.Item
        label="Description"
        name="description"
        initialValue={transaction.description}
      >
        <TextArea rows={4} placeholder="e.g. Initial Purchase" />
      </Form.Item>

      <Form.Item
        label="Reference Number"
        name="reference"
        initialValue={transaction.reference}
      >
        <Input placeholder="e.g. INV-2024-001" />
      </Form.Item>

      <Flex gap={'middle'}>
        <Form.Item
          style={{ flex: 1 }}
          label="Amount"
          name="amount"
          initialValue={-transaction.amount}
          rules={[{
            required: true,
            message: 'Please input Amount!',
          }]}>
          <InputNumber style={{ width: '100%' }} autoFocus={true} />
        </Form.Item>
        <Form.Item
          style={{ flex: 1 }}
          label="Settled"
          name="settled"
          initialValue={transaction.settled}
        >
          <input type="checkbox" checked={settled} onChange={(e) => {
            setSettled(e.target.checked)
          }} autoFocus={true} />
        </Form.Item>
      </Flex>

      <Flex gap={'middle'}>
        <Form.Item
          style={{ flex: 1 }}
          label="Start"
          name="startAt"
          initialValue={transaction.startAt ? dayjs(transaction.startAt) : null}
        >
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          style={{ flex: 1 }}
          label="End"
          name="endAt"
          initialValue={transaction.endAt ? dayjs(transaction.endAt) : null}
        >
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>
      </Flex>


    </Form>
  </Modal >
}